import _ from 'lodash';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class DealershipsFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const data = [];

        if (_.size(environment.get('CONFIG.DEALERS')) > 1) {
            data.push({
                name: 'brands',
                position: 1,
                visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterBrand),
                fields: [{
                    title: translate('Common.Brand'),
                    name: 'brands',
                    dataSource: environment.get('CONFIG.DEALERS').map(name => ({ text: name, value: name })),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        data.push({
            name: 'type',
            position: 2,
            visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterStoreType),
            fields: [{
                title: translate('Common.TypeOfStore'),
                name: 'type',
                dataSource: _.map(environment.get('CONFIG.FILTERS.CLIENT_TYPES'), (val) => ({ text: val, value: val })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        data.push({
            name: 'group',
            position: 3,
            visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterGroup),
            fields: [{
                title: translate('Common.Group'),
                name: 'group',
                dataSource: _(environment.get('CONFIG.FILTERS.DEALERS_STORES'))
                    .map((val) => ({ text: val.Grupo, value: val.Grupo }))
                    .uniqBy(val => val.text)
                    .orderBy(val => val.text)
                    .value(),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        if (this.options.showVMMDealerships) {
            data.push({
                name: 'segment',
                position: 4,
                visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterSegment),
                fields: [{
                    title: translate('Common.Segment'),
                    name: 'segment',
                    dataSource: _.map(environment.get('CONFIG.FILTERS.SEGMENT'), (segment) => ({ text: translateText(segment.name, true), value: segment.id })),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        data.push({
            name: 'fuelType',
            position: 5,
            visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterFuelType),
            fields: [{
                title: translate('Common.FuelType'),
                name: 'fuelType',
                dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        if (_.size(environment.get('CONFIG.STATES')) > 1) {
            data.push({
                name: 'state',
                position: 6,
                visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterUf),
                fields: [{
                    title: translate('Common.State'),
                    name: 'state',
                    dataSource: environment.get('CONFIG.STATES'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        data.push({
            name: 'storeTypeSaleMarket',
            position: 7,
            visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterStoreTypeSaleMarket),
            fields: [{
                title: translate('Common.FilterStoreTypeSalesMarket'),
                name: 'storeTypeSaleMarket',
                dataSource: _.map(environment.get('CONFIG.FILTERS.TYPE_SALES_MARKET'), (v) => ({ text: v.text, value: v.value })),
                value: 'value',
                text: 'text',
                skipAll: true,
                type: 'multiselect'
            }]
        });

        if (environment.get('CONFIG.FILTERS.STORE_CONTEXT_ATTRIBUTES')
            && environment.get('CONFIG.FILTERS.STORE_CONTEXT_ATTRIBUTES').length > 0
            && isAuthorized(FeaturePermission.LAYER_NETWORK.filterStoreAttribute)) {
            data.push({
                name: 'attribute_context',
                position: 8,
                visible: true,
                data: environment.get('CONFIG.FILTERS.STORE_CONTEXT_ATTRIBUTES'),
                fields: [
                    {
                        title: translate('Common.StoreContextAttribute'),
                        name: 'attributes',
                        text: 'attributeName',
                        value: 'idAttributeType',
                        skipAll: true,
                        type: 'multiselect',
                    }
                ]
            });

            data
                .filter(d => d.name === 'attribute_context')
                .forEach(d => {
                    const contexts = environment.get('CONFIG.FILTERS.STORE_CONTEXT_ATTRIBUTES')
                        .map(x => x.idContextAttribute)
                        .reduce((acc, curr) => acc.add(curr), new Set());

                    if (contexts.length > 1) {
                        d.fields = [
                            {
                                title: translate('Common.StoreContext'),
                                name: 'contextAttributes',
                                text: 'attributeContextName',
                                value: 'idAttributeContext',
                                type: 'dropdown',
                            },
                            ...d.fields
                        ];
                    }
                });
        }

        if (isAuthorized(FeaturePermission.LAYER_NETWORK.showGroupClient)) {
            data.push({
                name: 'groupClients',
                position: 3,
                visible: isAuthorized(FeaturePermission.LAYER_NETWORK.showGroupClient),
                fields: [{
                    title: `${translate('Common.Group')} ${translate('Common.Client')}`,
                    name: 'groupClient',
                    dataSource: environment.get('CONFIG.FILTERS.GROUPS_CLIENTS_NAME'),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (_.size(environment.get('CONFIG.FILTERS.AREAS_OPERATIONAL')) > 1) {
            data.push({
                name: 'areaOperational',
                position: 9,
                visible: isAuthorized(FeaturePermission.LAYER_NETWORK.filterInfluenceArea),
                fields: [{
                    title: translate(`Common.${environment.get('CONFIG.FILTERS.AREAS_OPERATIONAL')[0].text}`),
                    name: 'areaOperational',
                    dataSource: environment.get('CONFIG.FILTERS.AREAS_OPERATIONAL'),
                    value: 'value',
                    text: 'value',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        return data.filter(c => c.visible);
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/dealerships.factory.js